// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"485":"d9b82c2a","957":"9ff029e1","986":"86073e98","996":"035ad448"}[chunkId] + ".js";
};